'use client'

import React from "react";
import Link from "next/link";
import { useSelector } from "react-redux";

function FaqsStylistCard() {
  const language = useSelector((state) => state.language.language);
  // console.log(language,'Selected Language')
  const text = {    
    subTitle: language === "en" ? "Frequently Question Ask ": "अक्सर पूछे जाने वाले प्रश्न",
    titleFirst: language === "en" ? "Door to Door Beauty": "डोर टू डोर ब्यूटी",
    titleSecond: language === "en" ? "Parlour and Home Saloon ": "पार्लर और होम सैलून",
    cardLocationDescription: language === "en" 
      ? "At Door to Door Beauty, we understand that you may have questions about our services, booking process, and policies. To provide clarity and ensure a smooth experience for our clients, we've compiled a list of frequently asked questions (FAQ) along with detailed answers below."
      : "डोर टू डोर ब्यूटी में, हम समझते हैं कि आपको हमारी सेवाओं, बुकिंग प्रक्रिया और नीतियों के बारे में कुछ सवाल हो सकते हैं। हम यह सुनिश्चित करने के लिए कि हमारे ग्राहकों को एक सहज अनुभव हो, हमने अक्सर पूछे जाने वाले प्रश्न (FAQ) और उनके विस्तृत उत्तर नीचे दिए हैं।",
  };
  
  return (
    <div className="block mx-auto max-w-screen-2xl ">
      <div className="mx-auto max-w-screen-2xl px-4 sm:px-10">
        <div className="lg:p-16 p-6 bg-pink-600 shadow-sm border rounded-lg">
          <div className="w-full bg-white shadow-sm lg:px-10 lg:py-5 p-6 rounded-lg ">
            <div className="flex justify-between items-center">
              <div className="lg:w-3/5">
                <span className="text-base lg:text-lg">
                {text.subTitle}
                </span>
                <h2 className="text-lg lg:text-2xl font-bold mb-1">
                 {text.titleFirst}{" "}
                  <span className="text-pink-600">{text.titleSecond}</span>
                </h2>
                <p className="text-sm leading-6">
                {text.cardLocationDescription}
                </p>
                {/* <Link
                  className="lg:w-1/4 hover:no-underline text-md font-medium inline-block mt-5 px-8 py-3 bg-pink-600 text-center text-white rounded-full hover:text-white hover:bg-emerald-600"
                  to="/#"
                >
                  Book Now
                </Link> */}
              </div>
              <div className="w-1/5 flex-grow hidden lg:lexx md:flex md:justify-items-center lg:justify-end">
                <span
                  style={{
                    boxSizing: " border-box",
                    display: "inline-block",
                    overflow: "hidden",
                    width: "initial",
                    height: "initial",
                    background: "none",
                    opacity: " 1",
                    border: "0px",
                    margin: "0px",
                    padding: " 0px",
                    position: "relative",
                    maxWidth: "100%",
                  }}
                >
                  <img  
  loading="lazy"  // Lazy loading added here
src="/assets/img/delivery-boy.png" alt="faqs card" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FaqsStylistCard;